import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IEventTicketState }    from 'Redux/Slices/EventTicket/EventTicketSlice';
import { removeActionTypes }    from 'Utils/ReducerUtility';

export const deleteEventTicketRequest = (state: Draft<IEventTicketState>, { type }: PayloadAction<{ id: string }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const deleteEventTicketSuccess = (state: Draft<IEventTicketState>, { type, payload }: PayloadAction<{
  id: string
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  const newEntries = { ...state.entries };
  if (payload.id in newEntries) {
    delete newEntries[payload.id];
  }
  state.entries = newEntries;
};

export const deleteEventTicketFailure = (state: Draft<IEventTicketState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
